/* eslint-disable */

import React from "react";
import IsYouBirthdayLucky from "../features/is-your-birthday-lucky/view";

function Section() {
  return <IsYouBirthdayLucky />;
}

export default Section;
